import WebApp from '@twa-dev/sdk'
import { useUnit } from 'effector-react'
import { useEffect, useState } from 'react'
import { goToMain, goToOnboarding } from '@/app/routing/events'
import { $isUserLoading, $tgAccuntData, $userSettings, $userToken, getUserProfileFx } from '@/entities/user'
import { getSteamAuthUrlFx, authUserFx } from '@/entities/user'
import { LoadingScreen } from '@/shared/ui/loadingScreen'
import { useHideNav } from '@/shared/hooks/useHideNav'

export const StartPage = () => {
  useHideNav()
  const initData = WebApp.initData
  const isLoading = useUnit($isUserLoading)
  const userToken = useUnit($userToken)
  const userData = useUnit($tgAccuntData)
  const settings = useUnit($userSettings)
  const [isSettingsLoading, setIsSettingsLoading] = useState(true)

  useEffect(() => {
    if (initData) {
      console.warn('1')
      authUserFx({
        init_data: initData,
      })
    }
  }, [initData])

  useEffect(() => {
    if (userToken) {
      getSteamAuthUrlFx(userToken)
      getUserProfileFx(userToken).finally(() => setIsSettingsLoading(false))
    }
  }, [userToken])

  useEffect(() => {
    if (isLoading || isSettingsLoading) {
      return
    } else if (!settings.isOnboarded) {
      return goToOnboarding()
    } else if (userData && userData.user.steam_id && !isLoading && settings) {
      return goToMain()
    } else {
      return goToMain()
    }
  }, [isLoading, userData, settings, isSettingsLoading])

  return <LoadingScreen visible />
}
